import React, { useMemo, useEffect, useRef, useState } from 'react'
import {
  Button,
  Form,
  Row,
  Col,
  Table
} from '@themesberg/react-bootstrap'
import { motion } from 'framer-motion/dist/framer-motion'
import PaginationComponent from '../../../components/Pagination'
import useCmsListing from './hooks/useCmsListing'
import Trigger from '../../../components/OverlayTrigger'
import { AdminsRoutes } from '../../../routes'
import useCheckPermission from '../../../utils/checkPermission'
import ConfirmationModal from '../../../components/ConfirmationModal'
import { DeleteConfirmationModal } from "../../../components/ConfirmationModal"
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import ActionMenu from './ActionMenu'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import { CustomCol, StyledSelect } from './style'
import { tableColumnHeaders, categoryLinkOptions } from './constants'
import useTableCustom from '../../../components/CusotmFilter'
import TableErrorMessage from '../../../components/TableErrorMessage'
import Toggle from "../../../components/Toggle/Toggle";
import { ToggleConfirmationModal } from "../../../components/ConfirmationModal"
// import {categoryLinkOptions} from "../constants"




export default () => {
  const {
    page,
    limit,
    setPage,
    setLimit,
    setSearch,
    search,
    navigate,
    cmsData,
    totalPages,
    loading,
    handleStatusShow,
    statusShow,
    setStatusShow,
    handleYes,
    status,
    active,
    setActive,
    name,
    setDeleteConfirmation,
    deleteConfirmation,
    onHandleDeleteCms,
    handleToggleChange,
    onCancleToggleStatus,
    statusConfirmation,
    onToggleConfirmation

  } = useCmsListing()
  const { isHidden } = useCheckPermission()

  const isShowActionColumn = !isHidden({ module: { key: 'CMS', value: 'U' } }) || !isHidden({ module: { key: 'CMS', value: 'D' } }) || !isHidden({ module: { key: 'CMS', value: 'T' } })

  const dynamicTableHeaders = useMemo(() => {
    const headers = [...tableColumnHeaders.filter(col => col.value !== 'action')];
    if (isShowActionColumn) {
      headers.push({
        accessorKey: 'action',
        Header: 'Actions',
        value: 'action',
        label: 'Actions',
      });
    }

    return headers;
  }, [isShowActionColumn]);

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    cmsData?.rows,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "CMS_TABLE"
  );

  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");


  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 100;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [visibleColumns, cmsData]);

  const resetFilters = () => {
    setSearch('')
    setActive('')
    setPage(1)
    setLimit(10)
  }

  // Helper function to get modal title and subtitle
  const getModalContent = () => {
    const action = status ? 'Activate' : 'Deactivate'
    const statusText = status ? 'active' : 'inactive'

    return {
      title: `${action} CMS Page`,
      subtitle: `Are you sure you want to mark "${name}" as ${statusText}?`
    }
  }

  const modalContent = getModalContent()

  return (
    <>
      <div className='section-header-wrap mt-n3 mx-n3' ref={headerRef}>
        <Row className='align-items-center justify-content-between'>
          <Col>
            <h2 className='title-text'>CMS</h2>
          </Col>
          <Col lg={4} xs={5}>
            <div className='d-flex align-items-center gap-3 justify-content-end'>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Button
                  variant='btn btn-primary w-100'
                  onClick={() => navigate(AdminsRoutes.CreateCMS)}
                  hidden={isHidden({ module: { key: 'CMS', value: 'C' } })}
                  style={{ maxWidth: '140px' }}
                  className='d-flex'
                >
                  <AddCircleOutlineRoundedIcon className='me-2' />
                  <span>Create</span>
                </Button>
              </motion.div>
              <Col xs={2} className="text-end">
                <NotificationIconContainer />
              </Col>
            </div>
          </Col>
        </Row>
      </div>

      <div className='FormsBg' ref={filterRef}>
        <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>

          <CustomCol xs={12} md={4} lg={4}>
            <Form.Control
              type='search'
              value={search}
              placeholder='Search title, slug'
              onChange={(event) =>
                setSearch(
                  event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
                )}
              className="mb-2 mb-md-0"
            />
          </CustomCol>

          <CustomCol xs={12} md={3} lg={2}>
            <StyledSelect
              size="sm"
              value={active}
              onChange={(event) =>
                setActive(
                  event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
                )}
              className="mb-2 mb-md-0"
            >
              <option key='' value=''>Filter Status</option>
              <option key='' value=''>All</option>
              <option key='true' value>Active</option>
              <option key='false' value={false}>In-Active</option>
            </StyledSelect>
          </CustomCol>

          {/* <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col xs={12} md={2} lg={3} className="d-flex w-100">
              <div className="d-flex w-100 mt-2 mt-md-0 justify-content-between">
                <Button
                  className="d-flex align-items-center btn-primary gap-3"
                  style={{ height: '2.2rem', minWidth: 'max-content' }}
                  size="sm"
                  onClick={resetFilters}
                >
                  <span>Reset Filters</span>
                </Button>
              </div>
              {customColSetting}
            </Col>
          </Row> */}

          <Row className="g-2 align-items-center mt-2 mt-md-0 justify-content-center">
            <Col xs={12} md={8} lg={12}>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 w-100">
                <Button
                  className="d-flex align-items-center btn-primary gap-2"
                  style={{ height: '2.2rem', minWidth: 'max-content' }}
                  size="sm"
                  onClick={resetFilters}
                >
                  <span>Reset Filters</span>
                </Button>

                <div className="custom-col-setting-width">
                  {customColSetting}
                </div>
              </div>
            </Col>
          </Row>



        </Row>
      </div>

      {visibleColumns?.length > 0 ? <div className='TableBg mt-4 pt-1'>

        <Table striped responsive hover size='sm' className='text-center mt-3'>
          <thead className='thead-light'>
            <tr>
              {visibleColumns.map((h) => (
                <th key={h?.label}>{h?.label}</th>
              ))}
            </tr>
          </thead>



          <tbody id={loading ? 'cover-spin' : ''}>
            {!loading && Boolean(cmsData) && cmsData?.rows?.length > 0 && cmsData?.rows?.map((row) => (
              <tr key={row.cmsPageId}>
                {visibleColumns.map((col, index) => {
                  const key = col.accessorKey;
                  switch (key) {
                    case 'title':
                      return (
                        <td key={index}>
                          <Trigger message={row.title?.EN}>
                            <span
                              style={{ width: '150px', cursor: 'pointer' }}
                              onClick={() => navigate(`/admin/cms/details/${row.cmsPageId}`)}
                              className="text-link d-inline-block text-truncate"
                            >
                              {row.title?.EN}
                            </span>
                          </Trigger>
                        </td>
                      );

                    case 'portal':
                      return (
                        <td key={index}>
                          <Trigger message={row.tenant?.name ? `${row.tenant.name} (${row.tenant.domain})` : 'All'}>
                            <span
                              style={{ width: '150px', cursor: 'pointer' }}
                              className="d-inline-block text-truncate"
                            >
                              {row.tenant?.name ? `${row.tenant.name} (${row.tenant.domain})` : 'All'}
                            </span>
                          </Trigger>
                        </td>
                      ); // category

                    case 'category':
                      const category = categoryLinkOptions.find(cat => cat.value === row.category);

                      return (
                        <td key={index}>
                          <Trigger message={category ? category.label : 'All'}>
                            <span
                              style={{ width: '150px', cursor: 'pointer' }}
                              className="d-inline-block text-truncate"
                            >
                              {category ? category.label : 'N/A'}
                            </span>
                          </Trigger>
                        </td>
                      ); // category



                    case 'status':
                      return (
                        <td key={index}>
                          <Toggle
                            checked={row.isActive}
                            onChange={(e) => {
                              handleToggleChange(
                                row
                              );
                            }}
                            align="left"
                            size="small"
                          />
                          {/* {row.isActive
                            ? <span className="text-success">Active</span>
                            : <span className="text-danger">In Active</span>} */}
                        </td>
                      );

                    case 'action':
                      return (
                        <td key={index}>
                          <ActionMenu
                            cmsPageId={row.cmsPageId}
                            isHidden={isHidden}
                            handleStatusShow={handleStatusShow}
                            isActive={row.isActive}
                            tenantId={row.tenantId}
                            title={row.title}
                            navigate={navigate}
                            setDeleteConfirmation={setDeleteConfirmation}
                          />
                        </td>
                      );

                    default:
                      return <td key={index}>{row[key] ?? '--'}</td>;
                  }
                })}
              </tr>
            ))}

            {cmsData?.count === 0 && !loading && (
              <tr>
                <td colSpan={visibleColumns.length} className="text-danger text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>



        </Table>
        {cmsData?.count !== 0 && !loading && (
          <PaginationComponent
            page={cmsData?.count < page ? setPage(1) : page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            paginationRef={paginationRef}
            showTotalCount={true}
            totalCount={cmsData?.count}
            countText={"Total CMS :  "}

          />
        )}
      </div> : <TableErrorMessage />}

      <ConfirmationModal
        setShow={setStatusShow}
        show={statusShow}
        handleYes={handleYes}
        title={modalContent.title}
        subTitle={modalContent.subtitle}
        active={status}
        name={name}

      />


      {deleteConfirmation?.open ? <DeleteConfirmationModal
        handleDeleteYes={onHandleDeleteCms}
        setDeleteModalShow={() => setDeleteConfirmation({
          open: false,
          title: '',
        })}
        deleteModalShow={true}
        name={`${deleteConfirmation?.title} CMS`}
      /> : ""}

      {statusConfirmation?.isOpen && <ToggleConfirmationModal showConfirmModal={statusConfirmation?.isOpen} cancelStatusChange={onCancleToggleStatus} pendingStatusChange={statusConfirmation?.status} confirmStatusChange={onToggleConfirmation} moduleName={"CMS"} message={statusConfirmation?.name} />}


    </>
  )
}
